module.exports = __webpack_public_path__ + "h5/img/perform.911db702.png";